import { render, staticRenderFns } from "./PersonalItems.vue?vue&type=template&id=68c9ca61"
import script from "./PersonalItems.vue?vue&type=script&lang=js"
export * from "./PersonalItems.vue?vue&type=script&lang=js"
import style0 from "./PersonalItems.vue?vue&type=style&index=0&id=68c9ca61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports